import React, { useState } from 'react';
import OrdersTable from './OrdersTable';
import CustomerProfileDrawer from './CustomerProfileDrawer';
import NewOrderWithPricing from './NewOrderWithPricing';

export default function AdminOrders({ token, initialStatus = '', initialSmart = '', initialEcuFinderOnly = false, initialFilters = null, initialOpenOrderId = '', onOpenedOrderConsumed }) {
  const [openCustomerId, setOpenCustomerId] = useState(null);
  // Edit-order overlay state
  const [editingOrder, setEditingOrder] = useState(null);
  // Tick to force OrdersTable refresh after a successful edit
  const [refreshTick, setRefreshTick] = useState(0);

  return (
    <>
      <OrdersTable
        key={`ot-admin-${refreshTick}`}
        token={token}
        canEditPriority={true}
        canEditStatus={true}
        canImport={true}
        scope="admin"
        initialStatusFilter={initialStatus}
        initialSmartFilter={initialSmart}
        initialEcuFinderOnly={initialEcuFinderOnly}
        initialFilters={initialFilters}
        initialOpenOrderId={initialOpenOrderId}
        onOpenedOrderConsumed={onOpenedOrderConsumed}
        onOpenCustomer={setOpenCustomerId}
        onEditOrder={(o) => setEditingOrder(o)}
      />

      {openCustomerId && (
        <CustomerProfileDrawer
          token={token}
          customerId={openCustomerId}
          onClose={() => setOpenCustomerId(null)}
          onSaved={() => { /* close-on-save not desired here */ }}
        />
      )}

      {editingOrder && (
        <div className="fixed inset-0 z-[60] bg-slate-50 overflow-y-auto" data-testid="admin-edit-order-overlay">
          <NewOrderWithPricing
            // Pass a synthetic admin user so the wizard can read balance hints,
            // but the *order owner's* balance is what's actually checked
            // server-side, so this prop is largely cosmetic in admin edits.
            user={{ balance: 0, reserved: 0 }}
            token={token}
            editingOrder={editingOrder}
            // Admin area is strictly English — this pins every t() call
            // in the wizard (and its FinalPriceBar / MobileStickyBar
            // children) to the `en` resource bundle even if the
            // operator's UI language is set to ES/IT/etc.
            isAdmin={true}
            onCloseEdit={({ saved }) => {
              setEditingOrder(null);
              if (saved) setRefreshTick((t) => t + 1);
            }}
            onOrderCreated={() => { /* nothing */ }}
          />
        </div>
      )}
    </>
  );
}
